import Button from '@material-ui/core/Button';
import { createStyles, withStyles, Theme } from '@material-ui/core';


export const PasslyToolbarButton = withStyles((theme: Theme) =>
    createStyles({
        textSecondary: {
            color: theme.palette.common.white
        },
        label: {
            textTransform: 'none'
        }
    })
)(Button);
